import React from "react";
import MapContainer from "./MapContainer.jsx";
import WellKnownTextInput from "../presentational/WellKnownTextInput.jsx";
import CreditsDisplay from "../presentational/CreditsDisplay.jsx";
import ConsoleAppBar from "../presentational/ConsoleAppBar.jsx";

/**
 * Controls css styling for this component using js to css
 */
const css = {
  blockDisplay: {
    display: "block"
  },
  noneDisplay: {
    display: "none"
  }
};

/**
 * App is the parent component for all of the other components in the project. It
 * imports and creates all of the map and console components and contains the
 * target selector.
 *
 * @component
 */
export default function CartoCosmosApp(props) {

  // Read Parameters from URL (like a GET Request)
  const address = window.location.search;
  let parameterList = new URLSearchParams(address);
  let setup = new Map();
  parameterList.forEach((value, key) => {
    setup.set(key, value);
  });

  const setInputOrDefault = (parameterName, defaultValue) => {
    let myValue = setup.get(parameterName);
    if (typeof myValue == "undefined") {
      myValue = defaultValue;
    }
    return myValue
  }
  
  // Set initial parameters

  // Target Planet
  const target = setInputOrDefault("target", "mars");

  // Feature to Display
  const feature = setInputOrDefault("feature", "");

  // Coordinate System
  let coord_system = setup.get("coordinateSystem")
  if (typeof coord_system != "undefined"){
    if (coord_system.includes("West")) {
      setup.set("direction", "west");
    } else {
      setup.set("direction", "east");
    }

    if (coord_system.includes("centric")) {
      setup.set("system", "centric");
    } else {
      setup.set("system", "graphic");
    }

    if (coord_system.includes("180")) {
      setup.set("range", "180");
    } else {
      setup.set("range", "360");
    }
  }

  const coordinateSystem = {
    system: setInputOrDefault("system", "centric"),
    direction: setInputOrDefault("direction", "east"),
    range: setInputOrDefault("range", "360")
  };

  const accuracy = setInputOrDefault("accuracy", 3);

  // Controls and Auto-draw shape
  const hideControls = setInputOrDefault("hideControls", false);

  return (
    <>
      <ConsoleAppBar target={target} feature={feature} coordinateSystem={coordinateSystem} />
      <MapContainer
        target={target}
        accuracy={accuracy}
        coordinateSystem={coordinateSystem}
        astroWebMaps={props.astroWebMaps}
      />
      <div style={hideControls ? css.noneDisplay : css.blockDisplay}>
        <WellKnownTextInput
          accuracy={accuracy}
          style={css.noneDisplay}
        />
      </div>
      <CreditsDisplay />
    </>
  );
}
